var map = {
	"./book.svg": "53ab",
	"./builds.svg": "639e",
	"./computer.svg": "c8f8",
	"./door.svg": "5f6b",
	"./graps.svg": "809a",
	"./hood.svg": "3050",
	"./light.svg": "1a29",
	"./money.svg": "baa5",
	"./rocket.svg": "37a8",
	"./tractor.svg": "c5bb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8cb9";